import type { FunctionComponent } from 'react';
import { options } from './options';

type OptionListProps = {
  selectOption: () => void;
  currentPreference: number;
};

const OptionList: FunctionComponent<OptionListProps> = ({
  selectOption = () => null,
  currentPreference = 1,
}) => (
  <>
    <h3 className="preferences-body-title">
      Select the type of notifications you want to receive:
    </h3>
    <ul className="preference-list">
      {options.map((option) => (
        <label key={option.value} htmlFor={`radio-${option.value}`} className="option">
          <input
            id={`radio-${option.value}`}
            type="radio"
            value={option.value}
            checked={currentPreference === option.value}
            onChange={(e) => selectOption(+e.target.value)}
          />
          {option.label}
        </label>
      ))}
    </ul>
  </>
);

export default OptionList;
